"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isILoadExtensions = void 0;
function isILoadExtensions(value) {
    return "load" in value;
}
exports.isILoadExtensions = isILoadExtensions;
//# sourceMappingURL=ILoadExtensions.js.map